import { render } from "./formLoading.vue?vue&type=template&id=b2a0b3cc&scoped=true"
import script from "./formLoading.vue?vue&type=script&lang=js"
export * from "./formLoading.vue?vue&type=script&lang=js"

import "./formLoading.vue?vue&type=style&index=0&id=b2a0b3cc&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2a0b3cc"]])

export default __exports__